import { ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./Verify.scss";

function Verify() {
  return (
    <div className="verify">
      <FormattedMessage id="verify-message-1" />
      <p>
        <FormattedMessage id="verify-message-2" />{" "}
        <FormattedMessage id="verify-message-3" />{" "}
        <FormattedMessage id="verify-message-4" />
      </p>
      <div className="verify__button-container">
        <Link
          to={
            SessionHelper.isAsianRouteAndSessionView()
              ? ROUTES.asianAccountVerification
              : ROUTES.accountVerification
          }
          className={"verify__button-container__link"}
        >
          <span className="verify__button-container__button">
            <FormattedMessage tagName="span" id="start-verification" />
          </span>
        </Link>
      </div>
    </div>
  );
}
export default Verify;
